<template>

  <b-modal id="bv-modal-login" hide-footer>
    <template v-slot:modal-title></template>
    <div class="d-block text-center">
      <iframe class="loginIframe" :src="casLoginGuiURL" v-on:load="onLoginIframeLoad($event.target, $bvModal)"></iframe>
    </div>
  </b-modal>

</template>

<script>
import url from "@/rest/url";
import matomoTracking from "@/mixins/matomoTracking";

export default {
  name: "LoginModal",
  mixins: [matomoTracking],
  computed: {
    casLoginGuiURL() {
      return url.loginURL;
    }
  },
  methods: {
    onLoginIframeLoad: function(iframe, modal) {
      try {
        if (iframe.contentWindow && iframe.contentWindow.location && iframe.contentWindow.location.href) {
          let loc = iframe.contentWindow.location.href;
          if (loc.startsWith(url.loginSuccessURL)) {
            modal.hide('bv-modal-login');
            this.$store.dispatch('getUserDataWithOptionalAuthentication')
                .then(response => {
                  if(response == 'success'){
                    let userData = this.$store.getters.getUserData
                    this.setUserId(userData.eMailAdresse.toLowerCase())
                    this.trackPageView()
                  }
                })
          }
        }
      } catch (err) {
        // ignore
      }
    }
  }
}
</script>

<style scoped>
.loginIframe {
  border-width: 0px;
  width: 100%;
  height: 600px;
}
</style>